import { createAsyncThunk } from '@reduxjs/toolkit';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import {
  GetRehireAttributeDocument,
  GetRehireAttributeQueryResult,
  SetRehireAttributeDocument,
  SetRehireAttributeMutationResult,
} from '~/gql/graphql';

const getRehireAttribute = createAsyncThunk(
  'rehire/getRehireAttribute',
  async ({ companyId }: { companyId: number }, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<GetRehireAttributeQueryResult>(GetRehireAttributeDocument, { companyId });

      if (!res.data?.getRehireAttribute) return rejectWithValue(res);

      return {
        rehireAttributeId: res.data?.getRehireAttribute.attributeId,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const setRehireAttribute = createAsyncThunk(
  'rehire/setRehireAttribute',
  async ({ attributeId, companyId }: { attributeId: number; companyId: number }, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<SetRehireAttributeMutationResult>(SetRehireAttributeDocument, {
        attributeId,
        companyId,
      });

      if (!res.data?.setRehireAttribute)
        return rejectWithValue({
          ...res,
          success: false,
        });

      return {
        success: true,
        rehireAttributeId: attributeId,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const rehireAttributeActions = {
  getRehireAttribute,
  setRehireAttribute,
};
